import React from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

// Containers
import App from 'containers/App';

// Config
import config from 'config';

// Local
import { client } from './client';
import './i18n';

// Antd Styles
import 'antd/dist/antd.css';

// Global Styles
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
// wdyr
// used to debug when re-renders
// import './wdyr';

// Sentry
if (config.sentry.dns && config.sentry.enabled) {
  Sentry.init({
    dsn: config.sentry.dns,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
const root = createRoot(container);
root.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
);
